import React from "react";
import "./button.css";

interface SvgIconButtonProps {
  Icon?: React.ReactNode;
  onClick?: () => void;
}

const SvgIconButton: React.FC<SvgIconButtonProps> = ({ Icon, onClick }) => {
  return (
    <button type="button" className="btn-icon-primary counter-button" onClick={onClick}>
      {Icon}
    </button>
  );
};

export default SvgIconButton;
